module.exports = __webpack_public_path__ + "img/btm.79970c54.png";